export default class Option {

    id = '';
    name = '';
    description = '';
    defaultValue = '';
    type = '';

    constructor() {
    }
}
